<template>
  <section
    ref="container"
    class="page-container"
    @click="()=>{setPolicy=false}">
    <div
      class="main-header ">
      <div
        class="flex-sb type-margin">
        <div class="">
          <div class="header-title flex">
            <span
              v-if="merchant_platform"
              class="table-icon__img icon mg-r-15">
              <img :src="getOptionName('serverTypeIcon',merchant_platform)" >
            </span>
            <span class="icon" >
              <font-awesome-icon
                icon="ticket-alt"
                class="icon-color"/>
            </span>
            <span class="icon" >
              <span class="button-radius">{{detailData.type_language}}</span>
            </span>
            <span
              class="hcid ticket-number"> <span class="number-color">{{detailData.ticket_number}}</span></span>
          </div>

          <div class="header-title flex">
            <h3>{{ detailData.subject }}</h3>
          </div>
          <div class="flex flex-inline">
            <div>
              <span
                class="status-bar-span"
                :class="{
                  'pending':detailData.status==2,
                  'yellow':detailData.status==1,
                  'green':detailData.status==3
                }"
              >{{detailData.status_language}}</span>
            </div>
            <div v-if="detailData.stts">
              <span
                class="span-status-stts"
                :class="{
                  'yellow-dark':[201].includes(detailData.stts),
                  'blue': ![201].includes(detailData.stts),
                }"
              >{{detailData.stts_language}}</span>
            </div>
            <span class="header-date">Created</span>
            <span class="number-color number-fontsize">{{ detailData.created_at }}</span>
            <span class="header-date">Updated</span>
            <span class="number-color number-fontsize">{{ detailData.updated_at }}</span>

          </div>
        </div>
        <div class="form-item">
          <span>Assignee</span>
          <span>

            <v-select
              v-model="detailData.cs_id"
              icon="user-nurse"
              :list="assigneeList"
              :clearable="true"
              @change="selectAssignee"
            />
          </span>
        </div>
      </div>

      <div :class="showEdit?'':''" >
        <div  v-if="showMain">
          <section >
            <el-tabs v-model="activeTab">
              <el-tab-pane
                v-for="(tab, index) in referTab"
                :key="index"
                :label="tab.label"
                :name="String(tab.name)"
              ></el-tab-pane>
            </el-tabs>
          </section>
        </div>
      </div>
    </div>

    <div
      class="main-container">
      <div
        v-if="showMain"
        class="main-col">
        <div class="middle-col">
          <v-serviced-progress
            v-if="merchant_platform"
            :agency-name="detailData.agency_name"
            class="mg-b-20"
            :is-fina="isFina"></v-serviced-progress>
          <div
            v-if="customer_profile.block_data && customer_profile.block_data.length"
            class="warning">
            <block-warning
              v-if="customer_profile.block_data && customer_profile.block_data.length"
              :customerProfile="customer_profile"></block-warning>
          </div>
          <template v-if="status==3">
            <div
              class="status-bar resolved"
            >
              <div class="status-title">
                <span >
                  <font-awesome-icon
                    icon="check"
                    class="check"/>
                  This ticket has been marked as resolved.
                </span>
              </div>
              <div>
                <template >
                  <v-button @click="network().reopenTicket(0)">Reopen</v-button>
                </template>
              </div>
            </div>
          </template>
          <section >
            <div
              v-show="activeTab === '1'">
              <request-detail
                :isAttachCustomer="isAttachCustomer"
                :form="detailData"
                :customer="customer_profile"
                @edit="event().handlerRequestEdit(2)"/>
            </div>
            <!--            <div v-show="activeTab === '2'">-->
            <!--              <document-info-->
            <!--                :form="documentData"-->
            <!--                @edit="event().handlerRequestEdit(2)" />-->
            <!--            </div>-->
            <div v-show="activeTab == '4'">
              <internal-document
                :ticket-id='ticketId'
                :list='detailData.internal_doc'
                :customer="customer"
                :form="detailData.relation"
                :type="type"
                :is-ticket="true"
                @updateDetail="handlerGetTicketDetail">
              </internal-document>
            </div>
            <div v-show="activeTab === '3'">
              <support-log
                :logsData="supportLogsData"
                @change="changeSupportLogType" />
            </div>
          </section>
        </div>
        <div class="right-col">
          <template>
            <div
              v-if="!isVoidStatus&&!canReplyQuote"
              class="bg-block bg-small-blue">
              <p class="color-dark fs-14 fw-600">Buyable</p>
              <p class="fw-400">Buyable Quote(s) have been replied in this support ticket.</p>
              <v-button
                icon="eye"
                class="width-fill"
                gray
                @click="handleViewQuote"
              >View Quotes</v-button>
              <v-button
                v-if="showBuyable"
                icon="ban"
                class="width-fill"
                red
                @click="onWithdrawClick"
              >Withdraw Quote</v-button>
            </div>
            <div
              v-if="isVoidStatus"
              class="bg-block bg-small-blue void-status flex-align-center">
              <span class="void-color fw-600">This quote has been voided.</span>
            </div>
          </template>
          <template >
            <div
              v-if="canReplyQuote"
              class="bg-block  bg-warning__yellow">
              <span
                class="label">Actions</span>
              <v-button
                icon="reply"
                green
                class="width-fill"
                :disabled="!isAttachCustomer"
                @click="event().handleReplyQuote()">
                Reply Quote
              </v-button>
            </div>
          </template>

          <div class="box">
            <span
              class="label">Tickets</span>

            <div class="button-group">
              <span class="flex span-one">
                <font-awesome-icon
                  v-if="status==1"
                  icon="forward"></font-awesome-icon>
                <font-awesome-icon
                  v-if="status==2"
                  icon="check"></font-awesome-icon>
                <font-awesome-icon
                  v-if="status==3"
                  icon="exclamation-circle"></font-awesome-icon>
                <span
                  v-if="status==1"
                  @click="handlerSelectType(2)"> Set Handling</span>
                <span
                  v-if="status==2"
                  @click="handlerSelectType(3)"> Set Resolved</span>
                <span
                  v-if="status==3"
                  @click="handlerSelectType(4)"> Reopen Ticket</span>
              </span>
              <span
                class="span-two flex"
                @click.stop="handlerSetPolicy">
                <span
                  v-if="status==1"
                >New</span>
                <span
                  v-if="status==2"
                >Handling</span>
                <span
                  v-if="status==3"
                >Resolved</span>
                <i class="el-icon-caret-bottom"></i>
              </span>

            </div>
            <ul
              v-if="setPolicy"
              class="setting-menu">
              <li @click="handlerSelectType(1)">
                <div class="with-icon">
                  <i
                    v-show="status==1"
                    class="el-icon-check"></i>
                </div>
                <span>New</span>
              </li>
              <li @click="handlerSelectType(2)">
                <div class="with-icon">
                  <i
                    v-show="status==2"
                    class="el-icon-check"></i>
                </div>
                <span>Handling</span>
              </li>
              <li @click="handlerSelectType(3)">
                <div  class="with-icon">
                  <i
                    v-show="status==3"
                    class="el-icon-check"></i>
                </div>
                <span>Resolved</span>
              </li>
            </ul>

            <div
              class="button-width">
              <v-button
                icon="stopwatch"
                class="button-weight"
                :class="{'is_snooze':is_snooze==1}"
                :disabled="disabledSnooze"
                @click="handlerDialog('snooze-ticket')">
                {{is_snooze==1?`Snoozed til ${showHKTime(detailData.snooze_until)}`:'Snooze'}}
              </v-button>
            </div>
          </div>
          <div>
            <div
              class="box">
              <div class="flex flex-sb">
                <span class="title">Customer</span>
                <span
                  class="blue hand"
                  @click="editCustomer">{{detailData.customer && detailData.customer.created_at?'Edit':'Add'}}</span>
              </div>
              <div  v-if="detailData.customer && detailData.customer.created_at">
                <div class="flex flex-align-center">
                  <div class="customer-ava">
                    <img
                      :src="avt_pic"
                      alt="">
                  </div>
                  <span class="span-status">{{detailData.customer.identity==2?'Company':'Personal'}}</span>
                  <router-link
                    :to="{path:'/accounts/detail',query:{customer_id:customerType()}}"
                    class="flex flex-wrap">
                    <span
                      v-if="isShowName"
                      class="plan-name hand"
                      @click="viewCustomer()">{{ detailData.customer.isrd_nm }} &nbsp;</span>
                    <span
                      v-else
                      class="plan-name hand unname"
                      @click="viewCustomer()">Unnamed Account &nbsp;</span>
                    <span
                      v-if="detailData.customer.identity!==2&& detailData.customer.nick_name"
                      class="plan-name small hand"
                      @click="viewCustomer()">({{ detailData.customer.nick_name }})</span>
                  </router-link>


                </div>
                <ul>
                  <li>
                    <span>Joined</span>
                    <span>{{ detailData.customer.created_at }}</span>
                  </li>
                  <li>
                    <span>Policy Count</span>
                    <span>{{ detailData.customer.polices }}</span>
                  </li>
                  <li>
                    <span>Tags</span>
                    <span>
                      <div
                        v-if="customer_profile.upload_request_stts == 1 || customer_profile.is_tier_base || customer_profile.referral_coupon || customer_profile.referral_discount"
                        class="tag">
                        <div
                          v-if="customer_profile.upload_request_stts == 1"
                          class="span-tag unread-uplod">Unread Upload</div>
                        <div
                          v-if="customer_profile.is_tier_base"
                          class="span-tag professional-status">Professional</div>
                        <div
                          v-if="customer_profile.referral_coupon"
                          class="span-tag coupon-status">Custom Coupon</div>
                        <div
                          v-if="customer_profile.referral_discount"
                          class="span-tag discount-status">Custom Discount</div>
                      </div>

                      <div
                        v-if="customer_profile.verify_language"
                        class="tag">
                        <div
                          class="span-tag"
                          :class="{
                            'verified': customer_profile.verified == 20,
                            'pending_verify ': customer_profile.verified == -1,
                            'not_verify': customer_profile.verified == -2
                          }">{{ customer_profile.verify_language }}</div>
                      </div>

                      <div
                        v-if="customer_profile.is_flagged"
                        class="tag">
                        <div class="span-tag unread-uplod">
                          Flagged
                        </div>
                      </div>
                      <div
                        v-if="has_block_data"
                        class="tag">
                        <div class="span-tag not_verify">
                          Blocked
                        </div>
                      </div>
                    </span>
                  </li>
                </ul>
                <div class="flex-sb">
                  <span class="label">Description</span>
                  <span
                    class="edit hand blue"
                    @click="editDescription">Edit</span>
                </div>
                <div
                  class="description-content"
                  v-html="customer_description">
                </div>

              </div>
              <template v-else>
                <span class="unname none-data">No customer attached</span>
              </template>
              <contact-customer
                :customerId="detailData.customer_id"
                :phone="customer.phone||customer.contact_phone"
                :customerName="customer.isrd_nm"
                :email="customer.send_email"
                @success="handler().getUpdateDetailData(0)"
              />
            </div>
          </div>
          <div class="box box-remark">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkLogsData"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.agent }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                append="Add"
                @handlerAppend="handlerSendRemark"/>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!showMain"
        class="main-edit">
        <section v-if="showEdit">
          <edit-sme-kyc
            :form="detailData"
            :customerId="customerId"
            :is-edit="referEditType==0"
            :is-fina="isFina"
            @save-success="handlerSave"
            @refresh="handleUpdateDetail"
            @reply-all="handlerSave"
            @reply-complete="handlerSave"
            @cancel="cancelEdit" />
        </section>
      </div>
    </div>

    <to-top
      v-if="!showMain"
      :el='container'></to-top>

    <snooze-ticket
      ref="snooze-ticket"
      :ticketId="ticketId"
      :form="detailData"
      @success="handler().getUpdateDetailData(0)" />
    <resolve-ticket
      ref="resolve-ticket"
      :ticketId="ticketId"
      @success="handler().getUpdateDetailData(0)" />
    <add-remark
      ref="add-mark"
      @confirm="handlerAddRemark" />
    <contact-dialog
      ref="contact-dialog"
      :ticketId="ticketId"
      :initCustomerId="detailData.customer_id"
      :initPhone="customer? customer.phone||customer.contact_phone: ''"
      :initEmail="customer? customer.send_email: ''"
      :customerData="customerData"
      :shareLink="initContent"
      :type="contactType" />
    <attach-user
      ref="attach-user"
      :ticketId="ticketId"
      is-share
      :isNewSME="true"
      @shareUser="handleAttach" />

    <attach-quote
      ref="attach-quote"
      :ticketId="ticketId"
      :customerId="customerId"
      @success="handler().getUpdateDetailData(0)" />

    <related-tickets
      ref="related-tickets"
      :ticketId="ticketId"
      :referTickList="ticketSelectArr"
      @success="handler().getUpdateDetailData(0)" />

    <reject-request
      ref="reject-request"
      @yes="handlerRequestTransfer" />
    <transfer-funds ref="transfer-funds" />
    <reply-quote
      ref="reply-quote"
      @buyable="onUpgradeQuoteClick"
      @priceOnly="event().onReplyQuote()"></reply-quote>

    <edit-description
      ref="edit-description"
      :detailData="customer_profile"
      :customerId="customerId"
      @update="getUpdateAccountData"></edit-description>
  </section>
</template>
<script>

import {
  addTicketRemark,
  getTicketRemark,
  reopenTicket,
  setResolvedTicket,
  setTicketCs,
  setTicketUnsnooze
} from '@/api/ticket'
import {getAccountDetail} from '@/api/account'
import {mapActions, mapState} from 'vuex'

import {
  sendReferralSms,
} from '@/api/refer'
import {rejectCreditTransfer, removeCreditTransfer} from '@/api/credits'
import {rejectReferralRequest} from '@/api/request'
import {getSMETicketDetail,SMEAttachedCustomer,withdrawSMEQuote} from '@/api/new_sme'
import MixinOptions from '@/mixins/options'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

import TransferFunds from '../tickets/dialogs/transfer-funds'

import RejectRequest from '../tickets/dialogs/reject-request'


import BlockWarning from '@/views/components/block-warning'
import EditDescription from '@/views/accounts/dialog/edit-description'
import SupportLog from '../tickets/components/support-log'
import InternalDocument from '@/views/components/internal-document'
import DocumentInfo from '../tickets/components/document-info'
import RequestDetail from './components/request-detail'
import SnoozeTicket from '../tickets/dialogs/snooze-ticket.vue'
import ResolveTicket from '../tickets/dialogs/resolve-ticket'
import AddRemark from '../tickets/dialogs/add-remark'
import ContactDialog from '../tickets/dialogs/new-contact-dialog'
import AttachUser from '@/views/quoting/dialogs/attachCustomer'
import AttachQuote from '../tickets/dialogs/attach-quote'
import RelatedTickets from '../tickets/dialogs/related-tickets'

import ContactCustomer from '@/views/components/new-contact-customer'
import ReplyQuote from '../tickets/dialogs/reply-quote'
import EditSmeKyc from './components/edit-sme-kyc'
export default {
  name: 'Detail',
  components: {
    SupportLog,
    InternalDocument,
    RequestDetail,
    SnoozeTicket,
    ResolveTicket,
    AddRemark,
    ContactDialog,
    AttachUser,

    AttachQuote,
    RelatedTickets,
    ContactCustomer,
    // EditPolicy,
    // UndoEndorsement,
    // TheRefund,
    TransferFunds,

    // ChangeClaimStatus,
    // MoveTransferQueue,

    // ViewEndorsementQuote,
    // MockCalculate,
    RejectRequest,
    // setVoidQuote,
    // MarkAsEndorsed,
    ReplyQuote,
    BlockWarning,
    EditDescription,
    EditSmeKyc
  },
  mixins: [MixinOptions],
  data() {
    return {
      initContent: '',
      way: '',
      container: null,
      isUndo:false,
      showEdit: false,
      isEdit:false,
      showCreateAccount: false,
      // showReply: false,
      showOther: false,
      referEdit: false,
      businessEdit: false,
      referEditType: 0,
      isShowQuick:0,//edit request、edit 0 ，1 reply
      checkRefer:0,//0正常，1是refer 草稿（不用验证），2是编辑确认
      businessAddQuoteType: 1, // 1 - add quote, 2 - add policy
      setPolicy:false,
      policyType:1,
      // type: 1, // 1-General 一般 2-refer case 人工单 3-endorsement 改单
      // 4-credit transfer 奖励金？？？ 5-business 商用 6-Claims 索偿
      supportLogType: 0, // support logs 組件 type
      showMockCalculate: false,
      editStatus: false,
      contactType: 0,
      activeTab: '1',
      remarkDetail:{},
      referTab: [
        {
          label: 'Request Detail',
          name: '1'
        },
        // {
        //   label: 'Document',
        //   name: '2'
        // },
        {
          label: 'Internal Document',
          name: '4'
        },
        {
          label: 'Support Log',
          name: '3'
        },
      ],

      // data
      detailData: {
        relation: {
          client_profile: null
        }
      },
      referDetail: {},
      policyData: {},
      endorsePolicyData: {},
      changeCategory: '', // general 改成 其他 類型
      assignee: '',
      // 狀態
      relationForm: {},
      businessPolicyOrderId: '',
      customer_profile:{},
      message:'',
      step: 0,
      renewStts: 0,
      quoteUrl: ''
    }
  },
  computed: {
    ...mapState('common', ['globalOptions']),
    ...mapState('ticket', ['ticketData', 'referData', 'refreshPage']),
    merchant_platform(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform
    },
    isFina(){
      return this.merchant_platform == 2
    },
    customer_description(){
      let str = this.customer_profile.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    shareInitiator(){
      return this.referDetail.share_initiator
    },
    showPdf(){
      if(this.referDetail.reference_pdf_download_lists){
        return this.referDetail.reference_pdf_download_lists.length > 0
      }
      return false
    },
    avt_pic(){
      const {avatar_pic={}} = this.detailData.customer||{}
      return avatar_pic&&avatar_pic.url||''
    },
    relation() {
      const { relation } = this.detailData
      return relation || {}
    },
    contact_data(){
      const { contact_data } = this.detailData
      return contact_data || {}
    },
    productId() {
      return 80
      return this.detailData.relation.product_id
    },
    // 1-General 2-refer case 3-endorsement 4-credit transfer 5-business 6-Claims
    type() {
      // return 2 // 測試
      return this.detailData.type
    },
    // 控制 edit 顯示的是 change category 的還是 其他 edit 狀態
    showEditType() {
      return this.changeCategory !== ''? this.changeCategory: this.type
    },
    // 控制左邊 policy 和 quote info
    // 1-Open 2-Snooze 3-Resolved
    status() {
      return this.detailData.status || 1 // 優化 resolved
    },
    is_snooze() {
      let {is_snooze} = this.detailData||{}
      return is_snooze||''// 優化 resolved
    },
    ticketId() {
      let {ticket_id} =this.$route.query||{}
      return ticket_id
    },
    ticketSelectArr(){
      return this.detailData.relation_ticket_list||[]
    },
    referId() {
      return this.detailData.relation.refer_id
    },
    customerId() {
      return this.detailData.customer_id
    },
    supportLogsData() {
      // logs 數據
      return this.detailData.support_log || []
    },
    remarkLogsData() {
      // logs 數據
      return this.remarkDetail || []
    },
    showMain() {
      return !this.showEdit  && !this.showOther
    },
    isSmeBusiness() {
      const { product_id } = this.detailData.relation
      if(this.type == 7 && product_id < 50) return false
      return [5, 7].includes(Number(this.type))
    },
    showPolicyList() {
      const { product_id } = this.detailData.relation
      if(this.type == 7 && product_id < 50) return false

      return this.showPolicyAdded && [5, 7].includes(Number(this.type))
    },
    showPolicyAdded() {
      const { business_policy = [], business_quote = [] } = this.detailData
      return business_policy.length > 0
    },
    showQuoteAdded() {
      const { order_id } = this.detailData.relation
      const { policy_info } = this.detailData
      if(order_id && !policy_info) {
        return true
      }
      return false
    },
    showStatusBar() {
      return this.status == 3
    },
    isSMEProduct(){
      return  true
    },
    showRepliedChose() {
      const { refer_stts, customer_chose,product_id } = this.referDetail
      return [110, 105].includes(refer_stts) && customer_chose  === 1
    },
    disabledUpgradBtn() {
      // 該單狀態為 reject 金庸 upgrade 按鈕
      return this.referDetail.refer_stts == 105
    },
    showBuyable() {
      let {stts} = this.detailData||{}
      return stts==250
    },
    isVoidStatus() {
      let {stts} = this.detailData||{}
      return stts==0
    },
    showPaymentLock() {
      return this.referDetail.refer_stts === 120
    },
    showBought() {
      return this.referDetail.refer_stts === 125
    },
    showRejectTransfer() {
      return this.detailData.relation.status === 3
    },
    showRemoveQueue() {
      return this.detailData.relation.status === 4
    },
    isAttachCustomer(){
      let {customer={},customer_id}=this.detailData||{}
      let {isrd_nm=''} = customer||{}
      return customer_id>0||this.isFina
      return isrd_nm?true:false
    },
    disabledRequestEdit() {
      if(this.type === 3) {
        return this.detailData.relation.stts >= 201
      }
      if(this.type === 7) {
        const { order_id } = this.detailData.relation
        return !!order_id
      }
      return false
    },
    canReplyQuote(){
      let {stts} = this.detailData||{}
      return [201].includes(stts)
    },
    disabledSnooze() {
      return this.is_snooze === 1
    },
    disabledResolved() {
      return this.showStatusBar && this.is_snooze !== 1
    },
    disabledCreditMoveBtn() {
      const { status } = this.detailData
      // 1-pending, 2-paid, 3-cancel, 4-queue
      return [3, 4].includes(status)
    },
    disabledCreditRejectBtn() {
      const { status } = this.detailData
      // 1-pending, 2-paid, 3-cancel, 4-queue
      return [ 3, 4].includes(status)
    },
    showNewQuote() {
      const { relation } = this.detailData
      const { product_id } = relation
      return product_id < 50
    },
    disabledNewQuote() {
      const { relation } = this.detailData
      const { order_id } = relation
      return !this.isRegistered || !!order_id || this.isReferralRequestReject
    },
    disabledReferralReuqestAddPolicyBtn() {
      const { business_policy } = this.detailData
      return business_policy.length > 0 || !this.isRegistered || this.isReferralRequestReject
    },
    disabledReferralRequestRejectBtn() {
      const { relation } = this.detailData
      const { order_id } = relation
      return !!order_id || this.isReferralRequestReject
    },
    isRegistered() {
      const { relation } = this.detailData
      const { is_registered } = relation
      return !!is_registered
    },
    isReferralRequestQuoted() {
      const { relation } = this.detailData
      const { product_id, status, order_id } = relation
      return status === 0 && order_id && product_id < 50
    },
    isReferralRequestPolicy() {
      const { relation } = this.detailData
      const { product_id, status } = relation
      return status === 1 && product_id < 50
    },
    isReferralRequestReject() {
      const { relation } = this.detailData
      const { status } = relation
      return status === 2
    },
    title() {
      // 1-General 2-refer case 3-endorsement 4-credit transfer 5-business 6-Claims
      // 1=>'Open', 2=>'Snooze', 3=>'Resolved'
      let insuranceType = ''
      if(this.type == 5) {
        insuranceType = this.getOptionName('ticketOptions.allTypeOptions', this.detailData.relation.insurance_type)
      }
      const titleList = [
        'Can I claim when I am not in Hong Kong? Worry that someone may steal my car Customer Inputted Title',
        'Information Out of Guidelines During Final Underwriting',
        `Endorsement Request of Policy #${this.detailData.id}`,
        `Credit Transfer Request - ${this.detailData.relation.money}`,
        `Business Insurance Inquiry (${insuranceType})`,
        `Claim Request of Policy #${this.detailData.id}`
      ]
      const type = Number(this.type)-1
      return titleList[type]
    },
    claimDetailData() {
      const { id, relation } = this.detailData
      const {claim_log = []} = relation
      return {
        ticket_id: id,
        id: relation.id,
        log: claim_log
      }
    },
    showVoidQuoteBtn() {
      return this.detailData.stts != 0
    },
    isSignature(){
      const {is_signature} = this.referDetail
      return is_signature==1
    },
    customerData(){
      let{customer={}} = this.detailData||{}
      if(!customer)
        return {}
      return{
        contact_phone:customer.phone||'',
        contact_email:customer.send_email||''
      }
    },
    customer(){
      let{customer={}} = this.detailData||{}
      return customer||{}
    },
    orderId(){
      const { relation } = this.detailData||{}
      const { order_id } = relation ||{}
      return order_id||''
    },

    relationOrderId(){
      const { relation } = this.detailData || {}
      const { order_id } = relation || {}
      return order_id||''
    },
    isShowName(){
      let {customer,id_type} = this.detailData
      if(customer.isrd_nm)
        return customer.isrd_nm.trim()!=''
      else return  false
    },
    customerType() {
      return type =>{
        const {customer_id} =  this.detailData
        let customerId = customer_id
        // 一個是 client user
        if(type=='client') {
          customerId = this.detailData.relation.client_user_id
        }
        return  customerId||''
      }
    },
    pcyId(){
      return this.relationForm.pcy_id || this.policyData.pcy_id || this.detailData.relation.pcy_id
    },
    documentData(){
      return this.isSMEProduct?this.referData:this.detailData.relation
    },
    canQuoteAgain(){
      return this.type===2&&JSON.stringify(this.referDetail)!='{}'&&this.isSMEProduct||this.type==2&&!this.isSMEProduct
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile
      return block_data.length>0
    },
  },
  watch: {
    ticketId: {
      immediate:true,
      handler(val) {
        this.handler().initStatusUpdateData()
      }
    },
    // 刷新頁面數據
    refreshPage(val, old) {
      if(val > old) {
        let that = this
        setTimeout( ()=>{
          that.handler().initStatusUpdateData()
        },2000)
      }
    },
    customerId:{
      immediate:true,
      handler(val){
        if(val)
          this.network().getAccountDetail({customer_id:val})
      }
    },
  },
  async created() {
    //获取初始信息
    // await this.handler().getUpdateDetailData()
    this.checkOptionsData()
    this.setQuoteCase([])
  },
  mounted(){
    this.container = this.$refs['container'].parentElement
  },
  methods: {
    ...mapActions('common', ['setProductId', 'checkOptionsData', 'getCustomerOptionsPhone']),
    ...mapActions('ticket', ['setTicketData', 'setReferData','setQuoteCase']),
    ...mapActions('quote',['setQuoteForm']),
    ...mapActions('account', ['setCustomerId','setSelectCustomerData']),
    ...mapActions('smeQuote', ['setSmeQuickForm']),
    handleViewQuote(){
      let {order_id} = this.detailData||{}
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id,
          product_id: this.productId,
          sme_versions:3
        }
      })
    },
    handleAttach(id,data){
      this.network().SMEAttachedCustomer({customer_id:id})
    },
    getUpdateAccountData() {
      this.network().getAccountDetail({customer_id:this.customerId})
    },
    editDescription(){
      this.$refs['edit-description'].changeDialog()
    },
    handlerSetPolicy(){
      this.setPolicy =  !this.setPolicy
    },
    handlerSelectType(data){
      this.policyType=data
      this.setPolicy =false
      let params ={}
      if(data==2){
        params.is_new_handling=2
        this.network().setResolvedTicket(params)
      }
      if(data==3){
        this.network().setResolvedTicket()
      }
      if(data==4){
        this.network().reopenTicket(0)
      }
      if(data==1){
        params.is_new_handling=1
        this.network().setResolvedTicket(params)
      }
    },
    handlerDialog(target) {
      this.$refs[target].changeDialog()
    },
    routerTo(path) {
      this.$router.push(path)
    },
    selectAssignee(id) {
      id = id?id:0
      this.network().setTicketCs({
        ticket_id: [this.ticketId],
        assignee_id: id
      })
    },

    viewCustomer(type) {
      const {customer_id} =  this.detailData
      let customerId = customer_id
      // 一個是 client user
      if(type=='client') {
        customerId = this.detailData.relation.client_user_id
      }
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: customerId
        }
      })
    },
    viewTicket(ticketId) {
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: ticketId
        }
      })
    },
    onRejectTransfer() {
      this.$refs['reject-request'].changeDialog()
    },
    handlerRequestTransfer() {
      this.network().rejectCreditTransfer()
    },
    editCustomer(type) {
      this.$refs['attach-user'].showAttachCustomer()
    },
    openDialog(target) {
      this.$refs[target].changeDialog()
    },
    // 獲取 support logs type 數據
    changeSupportLogType(type) {
      this.supportLogType = type
      this.handler().getUpdateDetailData()
    },
    handlerSend(){
      let textareaElement = document.createElement('textarea')
      textareaElement.setAttribute('readonly', 'readonly') // 防止弹出输入编辑
      textareaElement .value = this.quoteUrl //将需要拷贝的内容设置到textarea元素中。
      document.body.appendChild(textareaElement )
      textareaElement .select() //选中textarea元素，以备调用系统copy函数复制其中的内容。
      let isSuccess = document.execCommand('copy')
      this.$NewMessageBox({
        title: 'Copy Link',
        message: 'The link has been copied to your clipboard',
        confirmBtn:'Done',
        btnType:'success'
      })
    },
    handlerAddRemark(data) {
      this.network().addTicketRemark({
        ticket_id: this.ticketId,
        ...data
      })
    },
    handlerSendRemark(msg) {
      let content = msg? msg : this.message
      this.network().addTicketRemark({
        ticket_id: this.ticketId,
        content
      })
    },
    handlerChangeCategory(type) {
      this.changeCategory = type
      this.showEdit = true
    },
    cancelEdit() {
      this.showEdit = false
      this.changeCategory = '' // 重置
    },
    nextStep(step){
      this.step = step
      this.showTips()
    },
    handleUpdateDetail(){
      this.handler().getUpdateDetailData()
    },

    handlerSave() {
      this.changeCategory = '' // 重置 change catagory 下拉框
      this.showEdit = false
      this.handler().getUpdateDetailData()
    },
    saveChangeCategory() {
      this.changeCategory = '' // 重置 change catagory 下拉框
      this.showEdit = false
      // this.network().getTicketDetail()
      this.handler().getUpdateDetailData()
    },
    // refer 編輯數據
    handlerReferSaveSuccess() {
      this.showEdit = false
      this.handler().getUpdateDetailData()
    },
    // withdraw quote
    onWithdrawClick() {
      let {order_id} = this.detailData||{}
      this.network().withdrawSMEQuote({
        order_id
      })
    },
    onUpgradeQuoteClick() {
      // todo
      this.handler().getUpdateDetailData()
      this.showEdit = true
      this.checkRefer = 2
      this.isShowQuick = 1
      this.referEditType = 2
    },
    handlerReferralSmsSend(content) {
      this.network().sendReferralSms(content)
    },
    showTips(){
      this.$refs['renew-tips'].changeDialog()
    },
    goViewQuote(id) {
      let order_id = id
      if(order_id instanceof Array) {
        order_id = order_id[0]
      }
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id,
          product_id: this.productId
        }
      })
    },
    changeClaimStatus(status) {
      this.detailData.relation.status = status
      this.handler().getUpdateDetailData()
    },
    handlerCreateAccountSuccess() {
      this.showCreateAccount = false
      this.showOther = false
      this.handler().getUpdateDetailData()
    },
    onNewAccount() {
      this.showCreateAccount = true
      this.showOther = true
    },
    handlerGetTicketDetail(){
      this.network().getTicketDetail()
    },

    event() {
      return {
        handleReplyQuote: () => {
          this.event().onReplyQuote()
        },
        onReplyQuote: () => {
          // todo  可能要根據 type 判斷
          // 直接去到 edit refer 頁
          this.showEdit = true
          this.isShowQuick = 1
          // 標記是 reply
          this.checkRefer = 1
          this.referEditType = 1

        },
        // 控制顯示 edit 頁面
        handlerRequestEdit: (type) => {
          this.showEdit = true
          this.isShowQuick = 0
          if(type == 2) {
            this.referEditType = 0 // 正常 edit
          }
        },
        onRemoveQueue: () => {
          this.network().removeCreditTransfer()
        },
        onAttatchTicket: () => {
          this.$refs['related-tickets'].changeDialog()
        }
      }
    },
    handler() {
      return {
        // 初始化頁面狀態並更新並更新詳情數據
        initStatusUpdateData: async () => {
          this.showEdit = false
          await  this.handler().getUpdateDetailData()
        },
        getUpdateDetailData: async () => {
          //获取信息详情
          this.showEdit = false
          await this.network().getSMETicketDetail()
          await this.network().getRemarkDetail()
        },
        getUpdateDetailReferData: async () => {
          await this.network().getSMETicketDetail()
        },
      }
    },
    network() {
      return {
        getAccountDetail: async ({customer_id}) => {
          const {data} = await getAccountDetail({
            customer_id
          })
          let {customer_profile} = data
          this.customer_profile = customer_profile
        },
        SMEAttachedCustomer: async ({customer_id}) => {
          const {data} = await SMEAttachedCustomer({
            customer_id,
            ticket_id:this.ticketId
          })
          this.network().getSMETicketDetail({hideLoading:true})
        },
        withdrawSMEQuote: async (params) => {
          const {data} = await withdrawSMEQuote({
            ...params,
          })
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          await this.network().getSMETicketDetail({hideLoading:true})
        },
        getSMETicketDetail: async (params = {}) => {
          const { data } = await getSMETicketDetail({
            id: this.ticketId,
            type: this.supportLogType,
            ...params
          })
          this.detailData = data
          this.assignee = this.detailData.cs_id
          this.setTicketData(data)
        },
        getRemarkDetail: async () => {
          const { data } = await getTicketRemark({
            ticket_id: this.ticketId,
          })
          this.remarkDetail = data
        },
        addTicketRemark: async params => {
          const { data } = await addTicketRemark(params)
          this.$refs['add-mark'].initData()
          this.handler().getUpdateDetailData()
          this.message = ''
          this.$message({
            type: 'success',
            message: data.message_language
          })
        },
        // unsnooze
        setTicketUnsnooze: async () => {
          const { data } = await setTicketUnsnooze({
            ticket_id: [this.detailData.id]
          })
          this.handler().getUpdateDetailData()
        },
        setTicketCs: async params => {
          const { data } = await setTicketCs(params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        reopenTicket: async () => {
          const { data } = await reopenTicket({
            ticket_id: this.detailData.id
          })
          this.handler().getUpdateDetailData()
        },
        rejectCreditTransfer: async () => {
          const { data } = await rejectCreditTransfer({
            transfer_id: this.detailData.relation.id
          })
          this.handler().getUpdateDetailData()
        },
        removeCreditTransfer: async () => {
          const { data } = await removeCreditTransfer({
            transfer_id: this.detailData.relation.id
          })
          this.handler().getUpdateDetailData()
        },
        // reject
        rejectReferralRequest: async () => {
          const { data } = await rejectReferralRequest({
            referral_request_id: this.detailData.relation.id
          })
          this.handler().getUpdateDetailData()
        },
        sendReferralSms: async content => {
          const { data } = await sendReferralSms({
            order_id: this.detailData.relation.order_id,
            content
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })
          // this.$refs['send-email-sms'].changeDialog()
        },
        setResolvedTicket: async (params) => {
          const { data } = await setResolvedTicket({
            ticket_id: [this.ticketId],
            ...params
          })
          this.handler().getUpdateDetailData(0)
        },
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/pay-main-header';
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .none-data{
    color: #6A737D;
  }
  .flex-wrap{
    flex-wrap: wrap;
    text-decoration: none;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }

  .span-status{
    padding: 1px 8px;
    color: #fff;
    border-radius: 50px;
    font-size: 14px;
    margin-right: 10px;
    background: #fff;
  }
  .status-bar-span{
    padding: 1px 8px;
    border-radius: 25px;
    white-space: nowrap;
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    background: #fff;
    margin-right: 15px;
  }
  .span-status-stts{
    //font-family: Inter;
    padding: 1px 8px;
    border-radius: 25px;
    white-space: nowrap;
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    margin-right: 15px;
    color: #fff!important;
    //height: 18px;

    //background: #E36209;
    border-radius: 100px;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }

  }
  .yellow{
    border: 1px solid #735C0F;
    color: #735C0F;
  }
  .pending{
    border: 1px solid #0366D6;
    color: #0366D6;
  }
  .green{
    border: 1px solid #22863A;
    color: #22863A;
  }
  .warning{
    padding: 20px 70px;
  }
  .main-container {
    padding: 0 70px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      width: 100%;
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }

    .middle-col {
      flex: 1;
      min-width: 600px;
      /*width: calc(100% - 280px)!important;*/
      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
        display: inline-block;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
        &.is_snooze{
          background: #DBAB09;
          border: 1px solid rgba(27, 31, 35, 0.15);
          color: #FFFFFF;
        }
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
            .tag{
              .span-tag{
                display: inline-block;
                border-radius: 100px;
                height: 18px;
                background: #FFFFFF;
                padding: 0px 8px;
                font-weight: 600;
                font-size: 12px;
                line-height: 18px;
                box-sizing: content-box;
                white-space: nowrap;
                margin-bottom: 4px;
                &.verified{
                  border: 1px solid #22863a;
                  color: #22863a;
                }
                &.pending_verify{
                  border: 1px solid #dbab09;
                  color: #dbab09;
                }
                &.not_verify{
                  border: 1px solid #d73a49;
                  color: #d73a49;
                }
                &.unread-uplod{
                  border: 1px solid #f66a0a;
                  color: #c24e00;
                }
                &.professional-status, &.coupon-status, &.discount-status{
                  border: 1px solid #0366d6;
                  color: #0366d6;
                }
                &.green {
                  background: #DCFFE4;
                  color: #28A745;
                  border: none;
                }
                &.orange {
                  background-color:#FFF5B1 ;
                  color:  #B08800;
                  border: none;
                }
                &.red {
                  background: #D73A49;
                  color:#fff;
                  border: none;
                }
              }
            }
          }

          span:first-child {
            font-weight: bold;
          }
        }
        li:first-child {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        li:last-child {
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-bottom: 1px solid #dddfe7;

        .title {
          margin-bottom: 5px;
        }
      }

      .action-box {
        margin: 10px -15px 0 -15px;
        padding: 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;
      }

      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }
      .amount-payable {
        border: 1px solid rgba(4,66,137,0.2);
        border-radius: 10px;
        background-color: #DBEDFF;
        //margin-bottom: 30px;
        &.border-b{
          margin-top: 0;
        }
        .title {
          margin-bottom: 0;
          padding-top: 15px;
          padding-bottom: 5px;
        }

        .amount {
          display: block;
          padding-bottom: 20px;
          font-size: 28px!important;
          color: #586069;
        }
        .payment-disblock{
          display: block!important;
          .size-blue{
            color: #0366D6;
            font-family: Inter;
            font-size: 12px;
            cursor: pointer;
          }
        }
        .payment-status{
          display:flex ;
          justify-content: space-between;
          margin-bottom: 10px;
          .flex{
            align-items: center;
          }
          .dot{
            margin-right: 8px;
            display: block;
            border-radius: 50%;
            height: 16px;
            width: 16px;
            border: 1px solid rgba(0,0,0,0.2);
            background-color: #D73A49;
          }
          .green{
            background: #28A745!important;
          }
          .icon{
            margin-right: 5px;
          }
          .text-color{
            color: #0366D6;
            font-size: 12px;
          }
          .size-italic{
            font-style:italic;
            font-size: 12px;
            color: #6A737D;
          }
        }
        .send-color{
          color: #0366D6;
          font-size: 14px;
          font-weight: 500;
        }
        .button-list{
          margin: 20px 0;
          .el-button{
            margin-right: 8px;
            width: 50%;
            font-size: 14px;
          }
        }

      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .dialog-container {
    padding-left: 15px;
    color: #616266;

    h1 {
      font-size: 24px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;

      h1 {
        font-size: 24px;
      }
    }

    .dialog-content {
      padding-top: 15px;

      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
}
.bg-small-blue {
  background: #B3D9FF;
  border-radius: 15px;
}

.bg-warning {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #e6a23d;
  color: white;
  p {
    padding-bottom: 5px;
  }
  .label {
    color: white;
  }
  &__yellow {
    background: #FFFBDD;
    border-radius: 15px;
    border: 1px solid rgba(176, 136, 0, 0.2);
    .flex,.flex__button{
      .width-80{
        width: 80%;
      }
    }
  }
}

::v-deep .edit-container{
  padding: 0px!important;
}
.tr-margin{
  margin-bottom: 10px;
}
.tr-a{
  display: block;
}


.setting  .page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .flex-wrap{
    flex-wrap: wrap;
    text-decoration: none;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }
  .main-container {
    padding: 0 70px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      width: 100%;
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }

    .middle-col {
      flex: 1;
      min-width: 600px;
      /*width: calc(100% - 280px)!important;*/
      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        text-decoration: none!important;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
          }

          span:first-child {
            font-weight: bold;
          }
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-bottom: 1px solid #dddfe7;

        .title {
          margin-bottom: 5px;
        }
      }

      .action-box {
        margin: 10px -15px 0 -15px;
        padding: 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;
      }

      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }
      .amount-payable {
        border: 1px solid rgba(4,66,137,0.2);
        border-radius: 10px;
        background-color: #DBEDFF;
        //margin-bottom: 30px;
        &.border-b{
          margin-top: 0;
        }
        .title {
          margin-bottom: 0;
          padding-top: 15px;
          padding-bottom: 5px;
        }

        .amount {
          display: block;
          padding-bottom: 20px;
          font-size: 28px!important;
          color: #586069;
        }
        .payment-disblock{
          display: block!important;
          .size-blue{
            color: #0366D6;
            font-family: Inter;
            font-size: 12px;
            cursor: pointer;
          }
        }
        .payment-status{
          display:flex ;
          justify-content: space-between;
          margin-bottom: 10px;
          .flex{
            align-items: center;
          }
          .dot{
            margin-right: 8px;
            display: block;
            border-radius: 50%;
            height: 16px;
            width: 16px;
            border: 1px solid rgba(0,0,0,0.2);
            background-color: #D73A49;
          }
          .green{
            background: #28A745!important;
          }
          .icon{
            margin-right: 5px;
          }
          .text-color{
            color: #0366D6;
            font-size: 12px;
          }
          .size-italic{
            font-style:italic;
            font-size: 12px;
            color: #6A737D;
          }
        }
        .send-color{
          color: #0366D6;
          font-size: 14px;
          font-weight: 500;
        }
        .button-list{
          margin: 20px 0;
          .el-button{
            margin-right: 8px;
            width: 50%;
            font-size: 14px;
          }
        }

      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .dialog-container {
    padding-left: 15px;
    color: #616266;

    h1 {
      font-size: 24px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;

      h1 {
        font-size: 24px;
      }
    }

    .dialog-content {
      padding-top: 15px;

      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 70px 0px 70px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FFF!important;
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
}
.bg-skyblue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #409eff;
  color: white;
  p {
    padding-bottom: 5px;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-blue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #d9ecff;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
    display: block;
  }
}
.bg-yellow {
  margin: 0px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #FFFBDD;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
    display: block;
  }
}

.bg-small-blue {
  background: #DBEDFF;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-block {
  //margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}

::v-deep .edit-container{
  padding: 0px!important;
}
.tr-margin{
  margin-bottom: 10px;
}
.setting-menu{
  list-style: none;
  background: #FFFFFF;
  //border: 1px solid #E1E4E8;
  border-radius: 6px;
  z-index: 100;
  margin-top: 0!important;
  position: absolute;
  margin-left: 22px;
  box-shadow: 0 1px 8px 0 rgba(27, 31, 35, 0.4);
  //box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);

  li{
    width: 256px;
    height: 33px;
    background: #FFFFFF;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #24292E!important;
    box-shadow: inset 0px -1px 0px #E1E4E8;
    cursor: pointer;
    .with-icon{
      width: 11px!important;
    }
    i{
      width: 11px;
    }
    span{
      margin-left: 10px;
    }
    &:last-child{
      box-shadow: none!important;
    }
  }


}
.button-group{
  background: #FAFBFC;
  display: flex;
  border: 1px solid rgba(27, 31, 35, 0.15);
  box-sizing: border-box;
  box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);
  border-radius: 6px 6px 6px 6px;
  height: 32px;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;

  .span-one{
    .icon{
      font-family: Font Awesome 5 Free;
      font-style: normal;
      font-weight: 900;
      font-size: 14px;
      line-height: 16px;
      /* identical to box height, or 114% */

      display: flex;
      align-items: center;
      text-align: center;

      /* btn/outline/text */

      color: #0366D6;
    }
    span{
      margin-left: 10px;
    }
    color: #0366D6;
    border-right: 1px solid #E1E4E8;
    width: 60%;
    align-items: center;
    text-align: center;
    display: flex;
    cursor: pointer;
    height: 100%;
    justify-content: center;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
  }
  .span-two{
    color: #24292E;
    width: 40%;
    align-items: center;
    text-align: center;
    display: flex;
    cursor: pointer;
    height: 100%;
    justify-content: center;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    span{
      margin-right: 10px;
    }
  }
}

.bg-small-blue {
  background: #DBEDFF;
}
.bg-danger {
  background: #f56c6d;
  color: white;
}

.border-left-blue {
  border-left: 5px solid #409EFF;
}
.border-left-warning {
  border-left: 5px solid #E6A23D;
}
.border-left-success {
  border-left: 5px solid #68C23A;
}
.box {
  //margin-top: 15px;
  .title{
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
  }
  .box-show{
    background: #F6F8FA;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
    .title{
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: #24292E;
    }
    .email{
      word-break: break-all;
      position: relative;
      .tips{
        position: absolute;
      }
    }
  }
}

.span-status{
  padding: 2px 10px;
  color: #fff;
  border-radius: 50px;
  font-size: 14px;
  margin-right: 10px;
}
.yellow{
  background-color: #DBAB09;
}
.purple{
  background-color: #6F42C1;
}
.green{
  background: #28A745;
  color: #28A745!important;
}
.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  //height: 50px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 30px;
  border: 1px solid rgba(23, 111, 44, 0.2);
  border-radius: 6px;
  &.snoozed {
    background: #E6A23D;
  }
  &.resolved {
    background: #DCFFE4;
    color: #24292E;
  }
  .check{
    color: #28A745!important;
  }
  .status-title {
    padding: 22px 0;
    span {
      display: flex;
      align-items: center;
    }
  }
  .svg-inline--fa {
    padding-right: 10px;
    color: white;
    font-size: 22px;
  }

}
.margin-top-none{
  margin-top: 0!important;
}
.main-header{
  padding: 20px 70px 0px 70px;
  border-bottom: 1px solid #D1D5DA;
  //background-color: #FAFBFC;
  background-color: #FFF!important;
  .button-radius{
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #24292E;
    padding: 1px 8px;
    background: #FFFFFF;
    border: 1px solid #6A737D;
    border-radius: 100px;
  }
  .ticket-number{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
    height: 20px;
  }
  .header-title{
    h3{
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 36px;
      letter-spacing: 0.3px;
      color: #24292E;
    }
  }
  .flex-inline{
    align-items: flex-end;
  }
  .header-date{
    //height: 20px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    //line-height: 20px;
    color: #586069;
    margin-right: 0;
  }
  .number-fontsize{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    //line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
    margin-left: 8px;
    margin-right: 15px;
  }
  .icon-color{
    color:#6A737D;
  }
  ::v-deep .el-tabs__header{
    margin-bottom: 0;
  }
  ::v-deep .el-tabs--top{
    margin-top: 0;
  }
  .margin-bottom{
    padding-bottom: 20px;
  }
  .type-margin{
    margin-bottom: 20px;
  }
}
.add-policy-list {
  margin-top: 15px;
  .add-policy-item {
    margin-bottom: 15px;
    font-size: 12px;
    color: white;
    .add-policy-label {
      display: block;
      padding-bottom: 5px;
      cursor: pointer;
      .ic-right {
        margin-left: 5px;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .bold {
      font-weight: bold;
    }
  }
}
.button-margin{
  margin-right: 8px!important;
}
.icon-backgroud-none{
  background: none!important;
  img{
    height: auto!important;
  }
}
.policy-span-status {
  background: none;
  border: 0px!important;
  &.green {
    color: #28a745!important;
  }
  &.orange {
    color: #E36209!important;
  }
  &.yellow-dark {
    color: #DBAB09!important;
  }
  &.blue {
    color: #0366D6!important;
  }
  &.red {
    color: #d73a49!important;
  }
  &.min-green {
    color: #dcffe4;
  }
  &.purple {
    color: #6F42C1;
  }
}
.plan-name{
  text-decoration: none!important;
}
.flex-icon{
  width: 70px;
  margin-right: 5px;
  display: flex;
  .icon{
    margin-right: 10px!important;
  }
  .icon-margin-top{
    margin-top: -1px;
  }
  //con-width{
  //  width: 22px;
  //  margin-right: 10px;
  //}
}

.status-box{
  padding: 15px;
  width: 280px;
  border-radius: 15px;
  &.yellow-bg{
    background: #FFFBDD;
    border: 1px solid rgba(176, 136, 0, 0.2);
  }
  &.blue-bg{
    background: #DBEDFF;
    border: 1px solid rgba(4, 66, 137, 0.2);
  }
  &.green-bg{
    background: #DCFFE4;
    border: 1px solid rgba(23, 111, 44, 0.2);
  }
  &.red-bg{
    background: #FFE3E6;
    border: 1px solid rgba(158, 28, 35, 0.2);
  }
  .box-title{
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    height: 20px;
  }
  .tips{
    font-weight: 400;
    font-size: 14px;
    margin-top: 10px;
  }
  .btn{
    margin-top: 10px;
    .el-button{
      height: 32px;
      border-radius: 6px;
      font-weight: 600;
      font-family: 'inter';
    }
    .green-btn{
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      color: #FFFFFF;
      /deep/.icon{
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .gray-red-btn{
      color: #D73A49;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    }
    .gray-black-btn{
      color: #24292E;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      /deep/.icon{
        color: #586069;
      }
    }
    .el-button+.el-button{
      margin: 0;
      margin-top: 10px;
    }
  }
}
span.edit{
  color: #0366D6;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.description-content{
  font-weight: 400;
  font-size: 14px;
  color: #24292E;
  margin-bottom: 15px;
}
</style>

